// These values should correspond with the config keys on the server side
export class AccountConfigType {
  static HIRE_SALES_REVENUE_CODE = 'hire_sales_revenue_code';
  static CONSUMABLE_SALES_REVENUE_CODE = 'consumable_sales_revenue_code';
  static HIRE_EQUIPMENT_SALES_REVENUE_CODE =
    'hire_equipment_sales_revenue_code';
  static RETAIL_SALES_REVENUE_CODE = 'retail_sales_revenue_code';
  static REPAIR_PARTS_REVENUE_CODE = 'repair_parts_revenue_code';
  static REPAIR_LABOUR_REVENUE_CODE = 'repair_labour_revenue_code';
  static DELIVERY_REVENUE_CODE = 'delivery_revenue_code';

  // Prefixes to currency config codes - suffixed with corresponding currency code
  static CHEQUE_PAYMENTS_PREFIX = 'cheque_payments_';
  static CASH_PAYMENTS_PREFIX = 'cash_payments_';
  static CARD_PAYMENTS = 'card_payments';
  static BANK_TRANSFER_PAYMENTS = 'bank_transfer_payments';

  static HIRE_EQUIPMENT_PURCHASES_CODE = 'hire_equipment_purchases_code';
  static RETAIL_PURCHASES_CODE = 'retail_purchases_code';
  static CONSUMABLE_PURCHASE_CODE = 'consumable_purchases_code';
}

export const AccountConfigTypeLabels = {
  [AccountConfigType.HIRE_SALES_REVENUE_CODE]: 'Hire Sales Revenue',
  [AccountConfigType.CONSUMABLE_SALES_REVENUE_CODE]: 'Consumable Sales Revenue',
  [AccountConfigType.HIRE_EQUIPMENT_SALES_REVENUE_CODE]:
    'Hire Equipment Sales Revenue',
  [AccountConfigType.RETAIL_SALES_REVENUE_CODE]: 'Retail Sales Revenue',
  [AccountConfigType.REPAIR_PARTS_REVENUE_CODE]: 'Repair Parts Revenue',
  [AccountConfigType.REPAIR_LABOUR_REVENUE_CODE]: 'Repair Labour Revenue',
  [AccountConfigType.DELIVERY_REVENUE_CODE]: 'Delivery Revenue',
  [AccountConfigType.CHEQUE_PAYMENTS_PREFIX]: 'Cheque Payments',
  [AccountConfigType.CASH_PAYMENTS_PREFIX]: 'Cash Payments',
  [AccountConfigType.CARD_PAYMENTS]: 'Card Payments',
  [AccountConfigType.BANK_TRANSFER_PAYMENTS]: 'Bank Transfer Payments',
  [AccountConfigType.HIRE_EQUIPMENT_PURCHASES_CODE]: 'Hire Equipment Purchases',
  [AccountConfigType.RETAIL_PURCHASES_CODE]: 'Retail Purchases',
  [AccountConfigType.CONSUMABLE_PURCHASE_CODE]: 'Consumable Purchases'
};
